/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Avatar_RemovedInputs */



/**
* | output |
* | --- |
* | "Avatar removed" |
*
* @param {Profile_Avatar_RemovedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_avatar_removed = /** @type {((inputs?: Profile_Avatar_RemovedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Avatar_RemovedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Avatar supprimé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Avatar eliminado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Avatar removido")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avatar rimosso")
	return /** @type {LocalizedString} */ ("Avatar removed")
});